import React from 'react'
import { Helmet } from 'react-helmet-async'
import Contact from '@/components/main/contact'
import SeoMetaData from '@/components/SeoMetaData'
import { config } from '@/lib/config'
import ContactUjTavasziCsoportContent from '@/components/contact/ContactUjTavasziCsoportContent'

export default function ContactUjTavasziCsoport() {
  return (
    <>
      <Helmet>
        <title>Kapcsolat - Új Tavaszi Csoport | BeArt Művészetterápia</title>
        <meta name="description" content="Jelentkezés Új Tavaszi Csoport programra" />
        <link rel="canonical" href="https://beart.hu/kapcsolat/uj-tavaszi-csoport" />
      </Helmet>
      
      <SeoMetaData
        seoTitle="Kapcsolat (Új Tavaszi Csoport) | BeArt Művészetterápia"
        seoDescription="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
      />
      
      <section className="mx-auto mb-8 mt-8 flex w-3/4 rounded-lg bg-[#ffcc99] bg-opacity-50 text-black shadow">
        <Contact
          title="Jelentkezés az Új Tavaszi Csoport programra"
          hidden="uj-tavaszi-csoport"
          content={<ContactUjTavasziCsoportContent />}
        >
          <img
            src={`${config.basePath}/images/tavaszi-csoport.jpg`}
            alt="Új Tavaszi Csoport"
            width={"100%"}
          />
        </Contact>
      </section>
    </>
  )
}
